export * from './map-details-tool.component';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/tool/tools/map-details-tool/index.ts